export const USER_RIGHTS = "USER_RIGHTS"